module.exports = __webpack_public_path__ + "img/user-avatar.c79d8870.png";